import styled, { keyframes } from 'styled-components';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;
const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

type BackgroundImageProps = {
  imageUrl: string;
};

export const BackgroundImage = styled('div')<BackgroundImageProps>`
  width: 500%;
  height: 500%;
  background-image: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  animation: ${fadeIn} 3s ${cubicBezier} 0.3s backwards;
`;

export const PerformancePill = styled('div')`
  background-color: ${({ theme }) => theme.color.noirRGBA(0.7)};
  width: max-content;
  border-radius: ${({ theme }) => theme.x0_75}px;
  padding-left: ${({ theme }) => theme.x0_75}px;
  padding-right: ${({ theme }) => theme.x0_75}px;
  margin-right: ${({ theme }) => theme.x0_75}px;
`;
